import { useField } from 'formik';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';

interface ImageFieldProps {
  label?: string;
  name: string;
  disabled?: boolean;
  hint?: string;
}

const ImageField = (props: ImageFieldProps) => {
  const { label, name, disabled, hint } = props;
  const [field, meta, helpers] = useField(name);
  const [thumb, setThumb] = useState(field.value);

  useEffect(() => {
    setThumb(field.value);
  }, [field.value]);

  const handleImageChange = (event) => {
    const reader = new FileReader();
    const file = event.target.files[0];

    // on new upload overwrite thumb to read file image
    if (file) {
      reader.onloadend = () => setThumb(reader.result);
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="ImageField form-group">
      <Row>
        <Col>
          <div>
            <label htmlFor={name}>{label || ''}</label>
            <input
              className="form-control"
              disabled={disabled}
              id={name}
              name={name}
              type="file"
              accept="image/png, image/gif, image/jpg, image/jpeg, image/webp"
              onChange={(event) => {
                helpers.setValue(event.currentTarget.files[0]);
                handleImageChange(event);
              }}
            />
          </div>
          <div className={meta.error ? 'is-invalid' : ''} />
          {meta.error && <div className="invalid-feedback">{meta.error}</div>}
          {thumb && (
            <img
              src={thumb}
              alt={field.value?.name || ''}
              className="img-thumbnail tw-mt-2"
              height={152}
              width={152}
            />
          )}
          <div className="hint">{hint || 'Photo'}</div>
        </Col>
      </Row>
    </div>
  );
};

export default ImageField;
